import React from "react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";
import { Card, CardContent } from "../ui/card";
import { X, Filter } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../ui/select";

const statusLabels = {
  draft: "Draft", under_review: "Under Review", pending_approval: "Pending Approval",
  approved: "Approved", active: "Active", expired: "Expired",
  terminated: "Terminated", archived: "Archived",
};

export function ContractsFilterPanel({ filters, setFilters, filterOptions, onApply, onClear }) {
  return (
    <Card className="border-cyan-200/50">
      <CardContent className="pt-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-9 gap-3">
          <FilterSelect label="Contract Type" value={filters.contract_type} field="contract_type" options={filterOptions.contract_types} setFilters={setFilters} filters={filters} testId="filter-type" />
          <FilterSelect label="Supplier" value={filters.supplier_name} field="supplier_name" options={filterOptions.suppliers} setFilters={setFilters} filters={filters} testId="filter-supplier" />
          <FilterSelect label="Creator" value={filters.creator_name} field="creator_name" options={(filterOptions.users || []).map(u => u.name)} setFilters={setFilters} filters={filters} testId="filter-creator" />
          <FilterSelect label="Owner" value={filters.owner_name} field="owner_name" options={(filterOptions.users || []).map(u => u.name)} setFilters={setFilters} filters={filters} testId="filter-owner" />
          <FilterSelect label="Department" value={filters.department} field="department" options={filterOptions.departments} setFilters={setFilters} filters={filters} testId="filter-department" />
          <FilterSelect label="Spend Category" value={filters.spend_category} field="spend_category" options={filterOptions.spend_categories} setFilters={setFilters} filters={filters} testId="filter-spend-category" />
          <FilterSelect label="Jurisdiction" value={filters.jurisdiction} field="jurisdiction" options={filterOptions.jurisdictions} setFilters={setFilters} filters={filters} testId="filter-jurisdiction" />
          <div className="space-y-1">
            <Label className="text-xs">Status</Label>
            <Select value={filters.status} onValueChange={(v) => setFilters({ ...filters, status: v === "_all" ? "" : v })}>
              <SelectTrigger className="rounded-sm h-9" data-testid="filter-status"><SelectValue placeholder="All" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="_all">All</SelectItem>
                {(filterOptions.statuses || []).map(s => <SelectItem key={s} value={s}>{statusLabels[s] || s}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1">
            <Label className="text-xs">Created From</Label>
            <Input type="date" value={filters.date_from} onChange={(e) => setFilters({ ...filters, date_from: e.target.value })} className="rounded-sm h-9" data-testid="filter-date-from" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs">Created To</Label>
            <Input type="date" value={filters.date_to} onChange={(e) => setFilters({ ...filters, date_to: e.target.value })} className="rounded-sm h-9" data-testid="filter-date-to" />
          </div>
          <div className="flex items-end gap-2">
            <Button size="sm" onClick={onApply} className="rounded-sm h-9 flex-1" data-testid="apply-filters-btn">Apply</Button>
            <Button size="sm" variant="ghost" onClick={onClear} className="rounded-sm h-9" data-testid="clear-filters-btn"><X size={14} /></Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

function FilterSelect({ label, value, field, options, setFilters, filters, testId }) {
  return (
    <div className="space-y-1">
      <Label className="text-xs">{label}</Label>
      <Select value={value} onValueChange={(v) => setFilters({ ...filters, [field]: v === "_all" ? "" : v })}>
        <SelectTrigger className="rounded-sm h-9" data-testid={testId}><SelectValue placeholder="All" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="_all">All</SelectItem>
          {(options || []).map(o => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
